import { cloneTemplate, fillOpening, setCompanyLogo, text } from './dom'
import { companies, followedOpenings } from './mock/data'
import { saveOpening, type Workspace, type PreviewActions } from './workspace'

export function createFollowing(root: HTMLElement, workspace: Workspace, actions: PreviewActions) {
  const page = root.querySelector<HTMLElement>('[data-marketing-page="following"]')!
  let company = 'all'
  let tab = 'unread'
  const scoped = () =>
    followedOpenings.filter(
      (opening) => workspace.follows.has(opening.company) && (company === 'all' || opening.company === company)
    )

  function render() {
    if (company !== 'all' && !workspace.follows.has(company)) company = 'all'
    const unread = scoped().filter((opening) => !workspace.read.has(opening.id)).length
    page.querySelector('[data-preview-follow-total]')!.textContent = `${workspace.follows.size} companies followed`
    page.querySelector('[data-preview-follow-unread]')!.textContent = String(
      followedOpenings.filter((opening) => workspace.follows.has(opening.company) && !workspace.read.has(opening.id))
        .length
    )
    page.querySelector('[data-preview-follow-count]')!.textContent = String(unread)
    page.querySelector('[data-preview-follow-title]')!.textContent = company === 'all' ? 'All companies' : company
    page.querySelector('[data-preview-follow-tab-unread]')!.textContent = String(unread)
    page.querySelector('[data-preview-follow-tab-read]')!.textContent = String(scoped().length - unread)
    page.querySelector('[data-preview-follow-company="all"]')!.setAttribute('aria-pressed', String(company === 'all'))
    page
      .querySelectorAll<HTMLElement>('[data-preview-follow-tab]')
      .forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.previewFollowTab === tab)))
    const follows = companies.filter((item) => workspace.follows.has(item.name))
    page.querySelector('[data-preview-follow-rail]')!.replaceChildren(
      ...follows.map((item) => {
        const row = cloneTemplate(root, 'company-button')
        row.dataset.previewFollowCompany = item.name
        row.removeAttribute('data-preview-select-company')
        row.setAttribute('aria-pressed', String(company === item.name))
        setCompanyLogo(root, row.querySelector<HTMLElement>('[data-preview-logo]')!, item.name)
        text(row, 'company', item.name)
        text(row, 'subtitle', `Checked ${item.checked}`)
        text(
          row,
          'count',
          String(
            followedOpenings.filter((opening) => opening.company === item.name && !workspace.read.has(opening.id))
              .length
          )
        )
        return row
      })
    )
    const list = scoped().filter((opening) => (tab === 'read') === workspace.read.has(opening.id))
    page.querySelector<HTMLElement>('[data-preview-follow-empty]')!.hidden = list.length > 0
    page.querySelector('[data-preview-follow-feed]')!.replaceChildren(
      ...follows
        .filter((item) => list.some((opening) => opening.company === item.name))
        .map((item) => {
          const group = cloneTemplate(root, 'following-group')
          group.dataset.company = item.name
          text(group, 'company', item.name)
          text(group, 'checked', `Checked ${item.checked}`)
          text(group, 'matches', item.matches.join(' OR '))
          setCompanyLogo(root, group.querySelector<HTMLElement>('[data-preview-logo]')!, item.name)
          group.querySelector('[data-preview-group-openings]')!.replaceChildren(
            ...list
              .filter((opening) => opening.company === item.name)
              .map((opening) => {
                const row = cloneTemplate(root, 'opening-row')
                fillOpening(root, row, opening)
                const saved = workspace.jobs.some((job) => job.id === opening.id)
                const save = row.querySelector<HTMLButtonElement>('[data-preview-save-job]')!
                save.disabled = saved
                save.textContent = saved ? '✓ On your board' : '+ Add to board'
                row.querySelector('[data-preview-mark-read]')!.textContent =
                  tab === 'read' ? 'Mark as unread' : 'Mark as read'
                return row
              })
          )
          return group
        })
    )
  }

  page.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('button')
    if (!button) return
    if (button.dataset.previewFollowCompany) {
      company = button.dataset.previewFollowCompany
      render()
    }
    if (button.dataset.previewFollowTab) {
      tab = button.dataset.previewFollowTab
      render()
    }
    const id = button.closest<HTMLElement>('[data-opening]')?.dataset.opening
    if (id && button.hasAttribute('data-preview-mark-read')) {
      if (workspace.read.has(id)) workspace.read.delete(id)
      else workspace.read.add(id)
      actions.changed()
    }
    if (id && button.hasAttribute('data-preview-save-job')) {
      saveOpening(workspace, followedOpenings.find((opening) => opening.id === id)!)
      actions.changed()
      actions.report('Added to your board.')
    }
  })
  return { render }
}
